export default "__VITE_ASSET__BvTypVBR__"